export default __webpack_public_path__ + "static/pairing-dont-421c17a6c9628bfc6620de902f9962fe.png";